var React = require('react');

function QuoteInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Fill 1"),React.createElement("g",{"id":"Design","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Advertise-PAge","transform":"translate(-625.000000, -4347.000000)","fill":"#FEFEFE"},React.createElement("path",{"d":"M712.951569,4347 L688,4399.70508 L688,4445 L739,4445 L739,4396.96188 L719.530684,4396.96188 L739,4347 L712.951569,4347 Z M649.95056,4347 L625,4399.70508 L625,4445 L676,4445 L676,4396.96188 L656.531471,4396.96188 L676,4347 L649.95056,4347 Z","id":"Fill-1"})))]);
}

QuoteInline.defaultProps = {"width":"114px","height":"98px","viewBox":"0 0 114 98","version":"1.1"};

module.exports = QuoteInline;

QuoteInline.default = QuoteInline;
